import React, { useState, useEffect } from "react";
import { TextField, Grid, Select, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import WeeklyDates from "./WeeklyDates";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useUserData } from "components/customHooks/userDataContext";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { BackButton, dayNightTimeArray } from "components/helpers";
import {
  getUserOrgDetails,
  submitTimesheet,
  getOrgProjectTasks,
} from "apiHandler/actions";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Box from "@mui/material/Box";
import DescriptionIcon from "@mui/icons-material/Description";

//modals
import AddWorkDetails from "components/modals/AddWorkDetails";

const TimeSheetManagement = () => {
  const navigate = useNavigate();

  const getFormattedDate = (date) => {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;
    return month + "/" + day + "/" + year;
  };

  function getSundayOfCurrentWeek(d) {
    const date = new Date(d);
    const day = date.getDay();
    const diff = date.getDate() - day + 0;
    date.setDate(diff);
    return date;
  }
  const sundayDate = getSundayOfCurrentWeek(new Date());

  const getTimeSpan = (prop) => {
    let value = prop.split("-");
    let [from, to] = value;
    from = Number(from) / 100;
    to = Number(to) / 100;
    let from_abs = Math.floor(from) * 60 + (from % 1).toFixed(2) * 100;
    let to_abs = Math.floor(to) * 60 + (to % 1).toFixed(2) * 100;
    let diff = to_abs - from_abs;
    let minutes = diff % 60;
    let hrs = (diff - minutes) / 60;
    return { hrs, minutes };
  };

  const userData = useUserData();
  const [supervisorName, setSupervisorName] = useState("");
  const [userOrgData, setUserOrgData] = useState({});
  const [organizationName, setOrganizationName] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState(sundayDate);
  const [projectTask, setProjectTask] = useState([
    { project_name: "Select", task_name: "Select" },
  ]);
  const formateDate = getFormattedDate(date);
  const [toggleProject, setToggleProject] = useState(true);
  const [toggleTasks, setToggleTasks] = useState(true);
  const [employeeSignature, setEmployeeSignature] = useState("");
  // const [supervisorSignature, setSupervisorSignature] = useState("");
  const [reverseData, setReverseData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        user_id: userData?.email,
      };
      const response = await getUserOrgDetails(payload);
      const projectTasks = await getOrgProjectTasks(payload);
      console.log("projectTasks", projectTasks);
      setProjectTask(projectTasks);
      setUserOrgData(response[0]);
      const data = response[0];
      setOrganizationName(data.org_name);
      setEmployeeSignature(data.user_first_name + " " + data.user_last_name);
      // setSupervisorSignature(data.supervisor_first_name + " " + data.supervisor_last_name)
      setSupervisorName(
        data.supervisor_first_name + " " + data.supervisor_last_name
      );
    };
    fetchData();
  }, []);

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const clients = projectTask.map((el) => {
    return el.client_name;
  });

  const filterClients = removeDuplicates(clients);

  const [showAddModal, setShowAddModal] = useState(false);
  const [datesList, setDatesList] = useState([]);

  const [employeeID, setEmployeeID] = useState(userData?.email);
  const [employeeName, setEmployeeName] = useState(
    userData?.first_name + " " + userData?.last_name
  );

  const [comment, setComment] = useState("");
  const [esDate, setEsDate] = useState(new Date());
  // const [ssDate, setSsDate] = useState(new Date());

  const [workID, setWorkID] = useState("");

  const break_hours_Data = () => {
    const data = datesList.reduce((a, b) => +a + +b.break_hrs, 0);
    return Number(data).toFixed(2);
  };
  const breakHours_1 = break_hours_Data();

  const total_hours_Data = () => {
    const data = datesList.reduce((a, b) => +a + +b.total_hrs, 0);
    return Number(data).toFixed(2);
  };
  const total_hours_1 = total_hours_Data();

  const non_billable_hoursData = () => {
    const data = datesList.reduce((a, b) => +a + +b.non_billable_hrs, 0);
    return Number(data).toFixed(2);
  };
  const non_billable_hours_1 = non_billable_hoursData();

  const total_work_hoursData = () => {
    const data = datesList.reduce((a, b) => +a + +b.work_hrs, 0);
    return Number(data).toFixed(2);
  };
  const total_work_hours_1 = total_work_hoursData();

  const handleClientDrpdownChange = async (e, event) => {
    const ary = projectTask.filter((el) => {
      return el.client_name === event.target.value;
    });

    const projects = ary.map((el) => {
      return el.project_name;
    });
    const filterProjects = removeDuplicates(projects);

    const tasks = ary.map((el) => {
      return el.task_name;
    });
    const filterTasks = removeDuplicates(tasks);

    let modified = datesList.map((row) => {
      if (row.id === e.row.id) {
        row.client_name = event.target.value;
        row.project_ary = filterProjects;
        row.task_ary = filterTasks;
        setToggleProject(false);
        setToggleTasks(false);
      }
      return row;
    });
    setDatesList(modified);
  };

  const handleProjectDrpdownChange = async (e, event) => {
    let modified = datesList.map((row) => {
      if (row.id === e.row.id) {
        row.project_name = event.target.value;
        row.project_ary[0] = event.target.value;
      }
      return row;
    });
    setDatesList(modified);
  };

  const handleFromTimeChange = (id, event) => {
    let modified = datesList.map((row) => {
      if (row.id === id) {
        row.check_in_time = event.target.value;
      }
      return row;
    });
    setDatesList(modified);
  };

  const checkInTimeHandler = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.check_in_time}
        onChange={(event) => handleFromTimeChange(e.row.id, event)}
      >
        {dayNightTimeArray.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleToTimeChange = (id, event) => {
    let x = event.target.value.slice("0", "2");
    let y = Number(x);

    let modified = datesList.map((row) => {
      if (row.id === id) {
        let cx = row.check_in_time.slice("0", "2");
        let cy = Number(cx);

        if (y > cy) {
          let a = row.check_in_time + "-" + event.target.value;
          let c = a.replaceAll(":", "");
          let b = getTimeSpan(c);

          let ax = b.minutes;
          let yy = 0;
          if (ax === 30) {
            yy = 50;
          } else {
            yy = ax;
          }

          const filterHoursData = b.hrs.toString() + "." + yy.toString();
          const roundCheckData = Number(filterHoursData);

          row.check_out_time = event.target.value;
          row.check_in_check_out_time = roundCheckData;
          row.total_hrs = roundCheckData - row.break_hrs;
          row.work_hrs = row.total_hrs - row.non_billable_hrs;
        } else {
          alert("Check-out Time should be greater than Check-in time.");
        }
      }
      return row;
    });
    setDatesList(modified);
  };

  const checkOutTimeHandler = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.check_out_time}
        onChange={(event) =>
          e.row.check_in_time === "00:00"
            ? alert("Please select Check-In time first")
            : handleToTimeChange(e.row.id, event)
        }
      >
        {dayNightTimeArray.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const clientDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.client_name}
        onChange={(event) => handleClientDrpdownChange(e, event)}
      >
        {filterClients.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const projectDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.project_name}
        onChange={(event) => handleProjectDrpdownChange(e, event)}
        disabled={toggleProject}
      >
        {e.row.project_ary.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleTaskDrpdownChange = async (e, event) => {
    let modified = datesList.map((row) => {
      if (row.id === e.row.id) {
        row.task_name = event.target.value;
        row.task_ary[0] = event.target.value;
      }
      return row;
    });
    setDatesList(modified);
  };

  const taskDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.task_name}
        onChange={(event) => handleTaskDrpdownChange(e, event)}
        disabled={toggleTasks}
      >
        {e.row.task_ary.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };
  const getIdData = (id) => {
    setWorkID(id);
  };

  const getData = (data) => {
    let modified = datesList.map((row) => {
      if (row?.id === workID) row.notes = data;
      return row;
    });
    setDatesList(modified);
  };

  const handleWorkTextChange = async (row) => {
    setShowAddModal(true);
    getIdData(row?.id);
    setReverseData(row.notes);
  };

  const handleBreakHours = async (e, event) => {
    let modified = datesList.map((row) => {
      if (row?.id === e.row?.id) {
        row.break_hrs = event.target.value;
        row.total_hrs = (
          row.check_in_check_out_time - event.target.value
        ).toFixed(2);
        row.work_hrs = row.total_hrs - row.non_billable_hrs;
      }
      return row;
    });
    setDatesList(modified);
  };

  const breakHoursInput = (e) => {
    return (
      <input
        style={{ width: 60, textAlign: "center" }}
        type="number"
        min="1"
        value={e.row.break_hrs}
        onChange={(event) => handleBreakHours(e, event)}
        disabled={e.row.check_in_check_out_time === 0 ? true : false}
      />
    );
  };

  const handleNonBillableHours = async (e, event) => {
    let modified = datesList.map((row) => {
      if (row?.id === e.row?.id) {
        row.non_billable_hrs = event.target.value;
        row.work_hrs = (row.total_hrs - event.target.value).toFixed(2);
      }
      return row;
    });
    setDatesList(modified);
  };

  const nonBillableHoursInput = (e) => {
    return (
      <input
        style={{ width: 60, textAlign: "center" }}
        type="number"
        min="1"
        value={e.row.non_billable_hrs}
        onChange={(event) => handleNonBillableHours(e, event)}
        disabled={e.row.check_in_check_out_time === 0 ? true : false}
      />
    );
  };

  const handleRowAdd = (data) => {
    const temp = [...datesList];
    temp.splice(data.id, 0, data);

    const a = temp.map((el, index) => {
      return {
        id: index,
        day: el.day,
        timesheet_date: el.timesheet_date,
        day_date: el.day_date,
        client_name: el.client_name,
        project_name: el.project_name,
        project_ary: el.project_ary,
        task_ary: el.task_ary,
        task_name: el.task_name,
        notes: el.notes,
        check_in_time: el.check_in_time,
        check_out_time: el.check_out_time,
        check_in_check_out_time: el.check_in_check_out_time,
        break_hrs: el.break_hrs,
        total_hrs: el.total_hrs,
        non_billable_hrs: el.non_billable_hrs,
        work_hrs: el.work_hrs,
      };
    });
    setDatesList(a);
  };

  const handleRowRomove = (id) => {
    let temp = [...datesList];
    const filterData = temp.filter((row) => {
      return row.id !== id;
    });
    setDatesList(filterData);
  };

  const handleTimesheetFormSubmit = async (status_data) => {
    let arrayCopy = JSON.parse(JSON.stringify(datesList));

    const a = arrayCopy.map((el) => {
      return {
        day: el.day,
        timesheet_date: el.timesheet_date,
        day_date: el.day_date,
        client_name: el.client_name,
        project_name: el.project_name,
        project_ary: el.project_ary,
        task_ary: el.task_ary,
        task_name: el.task_name,
        notes: el.notes,
        check_in_time: el.check_in_time,
        check_out_time: el.check_out_time,
        check_in_check_out_time: el.check_in_check_out_time,
        break_hrs: el.break_hrs,
        total_hrs: el.total_hrs,
        non_billable_hrs: el.non_billable_hrs,
        work_hrs: el.work_hrs,
      };
    });

    const payload = {
      user_id: userOrgData.user_id,
      org_id: userOrgData.org_id,
      week_start_date: formateDate.toString(),
      week_end_date: endDate,
      total_break_hrs: breakHours_1,
      total_non_billable_hrs: non_billable_hours_1,
      total_work_hrs: total_work_hours_1,
      total_hrs: total_hours_1,
      status: status_data,
      user_signature: employeeSignature,
      notes: comment,
      timesheet_dates_list: a,
    };
    const response = await submitTimesheet(payload);
    navigate("/timesheet");
    console.log("response", response);
  };

  const columns = [
    {
      field: "",
      headerName: "Action",
      minWidth: 100,
      align: "center",
      flex: 1,
      renderCell: (e) => (
        <>
          <IconButton onClick={() => handleRowAdd(e.row)} color="secondary">
            <AddIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleRowRomove(e.row.id)}
            color="secondary"
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleWorkTextChange(e.row)}
            color="secondary"
          >
            <DescriptionIcon fontSize="small" />
          </IconButton>
        </>
      ),
    },
    {
      field: "day_date",
      headerName: "Day",
      flex: 1,
      minWidth: 105,
    },
    {
      field: "client_name",
      headerName: "Client",
      flex: 1,
      minWidth: 150,
      renderCell: clientDropdown,
    },
    {
      field: "project_name",
      headerName: "Project",
      flex: 1,
      minWidth: 150,
      renderCell: projectDropdown,
    },
    {
      field: "task_name",
      headerName: "Task",
      flex: 1,
      minWidth: 140,
      renderCell: taskDropdown,
    },
    {
      field: "check_in_time",
      headerName: "Check-In",
      flex: 1,
      minWidth: 110,
      renderCell: checkInTimeHandler,
    },
    {
      field: "check_out_time",
      headerName: "Check-Out",
      flex: 1,
      minWidth: 120,
      renderCell: checkOutTimeHandler,
    },
    {
      field: "break_hrs",
      headerName: "Break Hours",
      align: "center",
      flex: 1,
      minWidth: 131,
      renderCell: breakHoursInput,
    },
    {
      field: "non_billable_hrs",
      headerName: "Non Billable Hours",
      align: "center",
      flex: 1,
      minWidth: 172,
      renderCell: nonBillableHoursInput,
    },
  ];

  const DataGridCustomFooterComponent = () => {
    return (
      <div>
        <span style={{ marginRight: "40px", fontWeight: "semibold" }}>
          {datesList.length
            ? `Total Break Hours: ${breakHours_1}`
            : `Total Break Hours: 0`}
        </span>
        <span style={{ marginRight: "40px", fontWeight: "semibold" }}>
          {datesList.length
            ? `Total Hours: ${total_hours_1}`
            : `Total Hours: 0`}
        </span>
        <span style={{ marginRight: "40px", fontWeight: "semibold" }}>
          {datesList.length
            ? `Total Non-Billable Hours: ${non_billable_hours_1}`
            : `Total Non-Billable Hours: 0`}
        </span>
        <span style={{ marginRight: "70px", fontWeight: "semibold" }}>
          {datesList.length
            ? `Total Work Hours: ${total_work_hours_1}`
            : `Total Work Hours: 0`}
        </span>
      </div>
    );
  };

  return (
    <div className="check-patient-modal" style={{ margin: "auto" }}>
      <Grid container spacing={2}>
        <Grid container item spacing={1}>
          <Grid item xs={10} sm={10} md={10}>
            <BackButton onClick={() => navigate(-1)} />
          </Grid>
          <Grid item xs={2} sm={2} md={2}>
            <button
              style={{
                float: "right",
                border: "none",
                color: "#d91a5f",
                padding: "3px",
              }}
              onClick={() => navigate("/login")}
            >
              <h4>Log Out</h4>
            </button>
          </Grid>
        </Grid>
        <Grid
          container
          item
          spacing={2}
          style={{ marginTop: "5px", marginBottom: "10px" }}
        >
          <Grid>
            <WeeklyDates
              setDatesList={setDatesList}
              setEndDate={setEndDate}
              date={date}
              setDate={setDate}
            />
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee ID</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={employeeID}
              onChange={(e) => setEmployeeID(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee Name</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Supervisor Name</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={supervisorName}
              onChange={(e) => setSupervisorName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Organization</span>
            <TextField
              variant="standard"
              type="text"
              className="full-width"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item xs={12} sm={12} md={12}>
            <Box
              sx={{
                "& .sun": {
                  backgroundColor: "#f5fffa",
                  color: "#1a3e72",
                },
                "& .mon": {
                  backgroundColor: "#b9d5ff91",
                  color: "#1a3e72",
                },
                "& .tue": {
                  backgroundColor: "#fafad2",
                  color: "#1a3e72",
                },
                "& .wed": {
                  backgroundColor: "#E6E6FA",
                  color: "#1a3e72",
                },
                "& .thu": {
                  backgroundColor: "#F0FFFF ",
                  color: "#1a3e72",
                },
                "& .fri": {
                  backgroundColor: "#FFE4E1",
                  color: "#1a3e72",
                },
              }}
            >
              <DataGrid
                rows={datesList}
                columns={columns}
                autoHeight
                disableRowSelectionOnClick
                pagination
                pageSize={50}
                density="compact"
                components={{
                  Pagination: DataGridCustomFooterComponent,
                }}
                getCellClassName={(params) => {
                  if (params.row.day === "Sun") {
                    return "sun";
                  } else if (params.row.day === "Mon") {
                    return "mon";
                  } else if (params.row.day === "Tue") {
                    return "tue";
                  } else if (params.row.day === "Wed") {
                    return "wed";
                  } else if (params.row.day === "Thu") {
                    return "thu";
                  } else if (params.row.day === "Fri") {
                    return "fri";
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid container item spacing={1}>
            <Grid item xs={6} sm={6} md={12}>
              <span style={{ color: "#cb3366" }}>Comment</span>
              <TextField
                variant="standard"
                type="text"
                className="full-width"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <span style={{ color: "#cb3366" }}>Employee Signature</span>
              <TextField
                variant="standard"
                type="text"
                className="full-width"
                value={employeeSignature}
                onChange={(e) => setEmployeeSignature(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <span style={{ color: "#cb3366" }}>Date</span>
              <KeyboardDatePicker
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                value={esDate}
                onChange={(e) => setEsDate(e)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className="udm-btn-cont">
        <Button
          size="small"
          variant="outlined"
          color="error"
          style={{
            marginTop: "10px",
          }}
          onClick={() =>
            1 > total_work_hours_1
              ? alert("please select check-in/checkout time first")
              : handleTimesheetFormSubmit("Submitted")
          }
        >
          Submit
        </Button>
        <Button
          variant="contained"
          size="small"
          style={{
            color: "white",
            backgroundColor: "#cb3366",
            marginTop: "10px",
            marginLeft: "10px",
          }}
          onClick={() =>
            1 > total_work_hours_1
              ? alert("please select check-in/checkout time first")
              : handleTimesheetFormSubmit("Draft")
          }
        >
          Save
        </Button>
      </div>
      {showAddModal ? (
        <AddWorkDetails
          getData={getData}
          reverseData={reverseData}
          onClose={() => setShowAddModal(false)}
        />
      ) : null}
    </div>
  );
};

export default TimeSheetManagement;
